/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seller_Notice_Sold_ByInputs */

const en_seller_notice_sold_by = /** @type {(inputs: Seller_Notice_Sold_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sold by ${i?.name}`)
};

const pl_seller_notice_sold_by = /** @type {(inputs: Seller_Notice_Sold_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sprzedawca: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Sold by {name}" |
*
* @param {Seller_Notice_Sold_ByInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_sold_by = /** @type {((inputs: Seller_Notice_Sold_ByInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_Sold_ByInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_sold_by(inputs)
	return en_seller_notice_sold_by(inputs)
});